import { generateQueryString } from '../../components/common/Helpers/queryParams';
import { URL_MAPPER_MOVERS } from './UrlMapping';

/**
 *@name - saveProcessStep
 *@param1 - processStep name given by pega
 *@description - save process step to window object.
 */
export const saveProcessStep = (process_Step = '') => {
  window.process_Step = process_Step;
};

/**
 * @name - getProcessStep
 * @description - return process step from window object
 */
export const getProcessStep = () => window.process_Step;

export const goToMoversProcess = (processStep = '') => {
  try {
    const PROCESS_STEP = processStep.toUpperCase();
    const contractObj = getMoversContract(PROCESS_STEP);

    const shouldUseHistory = window.vzFlags?.history && contractObj && contractObj.useHistory && contractObj.URL?.includes('.html');
    if (shouldUseHistory) {
      // history.push(contractObj.URL);
      window.vzFlags.history.push(contractObj.URL);
    } else {
      window.location.href = contractObj.URL;
    }
  } catch (e) {
    console.log(e);
  }
};

/**
 * @name - getFinalURL
 * @param1 - processStep name given by pega
 * @param2 - queryparams to be added as part of the URL redirection
 */
const getMoversContract = (PROCESS_STEP = '') => {
  /**
   * This controls which page should be passed with the query parameters
   */
  let contractObj = {};
  const params = [];

  switch (PROCESS_STEP) {
    case 'MOVERS_APPOINTMENT':
    case 'MOVERS_ORDER_REVIEW':
    case 'MOVERS_CONFIRMATION':
    case 'MOVERS_PLANS_OVER_VIEW':
      contractObj = {
        URL: `${URL_MAPPER_MOVERS[PROCESS_STEP]}${generateQueryString(params)}`,
        useHistory: true,
      };
      break;

    default:
      contractObj = {
        URL: URL_MAPPER_MOVERS[PROCESS_STEP] ? URL_MAPPER_MOVERS[PROCESS_STEP] : URL_MAPPER_MOVERS.GENERIC_ERROR,
        useHistory: false,
      };
  }
  return contractObj;
};
